import styled from "@emotion/styled";

const SidebarAndMainWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  background-color: #ededed;
`;

export default SidebarAndMainWrapper;
